import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import AgeVerification from "../components/AgeVerification";
import "../App.css";

//header
import laCasera from "../images/la-casera-Logo.png";
import heroBg from "../images/heroBg.jpg";
import heroBgMob from "../images/heroBgMob.jpg";
import hero from "../images/header.png";
import heroMob from "../images/headerMob.png";

//about us
import famous from "../images/famous.png";
import famousMob from "../images/famousMob.png";

//flavours
import midBg from "../images/midBg.jpg";
import midBgMob from "../images/midBgMob.jpg";
import red from "../images/red.png";
import white from "../images/white.png";

//where to buy
import amazon from "../images/amazon.png";
import whsmith from "../images/whsmith.png";

//footer
import drinkware from "../images/drinkaware.png";
import footDesk from "../images/footerDesk.jpg";
import footMob from "../images/footerMob.jpg";
import crack from "../images/crackLacasera.png";

const Home = () => {
  const [backgroundImage, setBackgroundImage] = useState(
    window.innerWidth < 904 ? heroBgMob : heroBg
  );

  const [fam, setFam] = useState(window.innerWidth < 904 ? famousMob : famous);
  const [midImage, setMidImage] = useState(
    window.innerWidth < 904 ? midBgMob : midBg
  );

  const [footImage, setFootImage] = useState(
    window.innerWidth < 904 ? footMob : footDesk
  );

  const [heroImage, setHeroImage] = useState(
    window.innerWidth < 904 ? heroMob : hero
  );

  const [isContentVisible, setIsContentVisible] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  //eslint-disable-next-line
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [isAndroid, isChrome] = useDeviceDetect();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to check URL and scroll to section if it matches

  const extractIdFromUrl = useCallback(() => {
    const url = window.location.href;
    // Define the ending pattern for the URL
    const pattern = /\/([^/]+)\/?$/; // Remove unnecessary escape character
    // Match the pattern against the URL
    const match = url.match(pattern);
    if (match && match[1]) {
      // Extracted ID is the captured group from the regex
      const extractedId = match[1].replace("#", ""); // Remove '#' character
      return extractedId;
    }
    return null; // Return null if no match found
  }, []);

  const checkUrlAndScroll = useCallback(() => {
    const id = extractIdFromUrl();
    if (id) {
      id === "flavours" ? scrollNormal(id) : scrollToSection(id);
    }
  }, [extractIdFromUrl]);

  useEffect(() => {
    checkUrlAndScroll();
  }, [checkUrlAndScroll]);

  //useEffect to monitor whether ageVerification is verified then run checkUrLAndSroll after 1/2 sec
  useEffect(() => {
    if (isVerified) {
      setIsContentVisible(true);

      const remainingTime = 500;
      const delayAfterFunctionCompletes = remainingTime + 0;

      setTimeout(() => {
        checkUrlAndScroll();
      }, delayAfterFunctionCompletes);
    }
  }, [isVerified, checkUrlAndScroll]); // Runs only when isVerified changes to true

  //function to control scroll to section when coming from different page
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const windowHeight = window.innerHeight;
      let finalScrollPosition = section.offsetTop - windowHeight * 0.25;
      const windowWidth = window.innerWidth;
      if (windowWidth > 1100) finalScrollPosition += 150;
      else if (windowWidth > 768) finalScrollPosition += 80;
      else if (windowWidth > 600) finalScrollPosition += 130;
      else finalScrollPosition += 60;
      finalScrollPosition = Math.max(finalScrollPosition, 0);
      window.scrollTo({ top: finalScrollPosition, behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  //function to control scroll to section on home page
  const scrollNormal = (id) => {
    const section = document.getElementById(id);
    console.log(id);

    if (section) {
      const finalScrollPosition = section.offsetTop;
      console.log(finalScrollPosition);

      window.scrollTo({
        top: finalScrollPosition,
        behavior: "smooth",
      });

      // Close the navigation overlay after scrolling
      setIsMenuOpen(false);
    }
  };

  // useEffect for image swaps from Desktop to Mobile at 904px width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 904) {
        setBackgroundImage(heroBgMob);
        setFam(famousMob);
        setMidImage(midBgMob);
        setFootImage(footMob);
        setHeroImage(heroMob);
      } else {
        setBackgroundImage(heroBg);
        setFam(famous);
        setMidImage(midBg);
        setFootImage(footDesk);
        setHeroImage(hero);
      }
    };

    // Listen for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener when component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="App  h-full">
      {!isVerified ? (
        /* AGE VERIFICATION -----------------------------------------------------------------*/
        <AgeVerification onVerify={setIsVerified} />
      ) : (
        <div>
          {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //////////////////////////////////////////// HEADER SECTION /////////////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
          <div
            style={{
              display: isContentVisible ? "block" : "none",
              position: isContentVisible ? "relative" : "fixed",
            }}
            className=" header bg-[#670001] "
          >
            {/* --------------------------------------Navigation bar------------------------------------------------------------------ */}

            <div
              className={` mx-auto max-w-[1440px] x904:h-[128px] absolute w-full z-[11] left-1/2 translate-x-[-50%]  flex items-center   justify-between `}
            >
              {/* Reload page */}
              <Link to="/" className="cursor-pointer">
                <img
                  src={laCasera}
                  className=" cursor-pointer z-20 x904:mt-6 sms:mt-6 sm:mt-6 mob2:mt-6 xs:mt-4 x904:ml-12 xs:ml-[20%]  x904:w-[125px]  sms:w-[180px] sm:w-[145px] mob2:w-[100px]  xs:w-[80px]  "
                  alt=" La Casera logo"
                />
              </Link>
              {/* Burger SVG (conditionally rendered based on screen width) */}
              <svg
                onClick={toggleMenu}
                className=" z-20 x904:hidden ml-4 sms:h-16 sms:w-16 sm:w-14 sm:h-14 mob2:w-10 mob2:h-10 xs:w-8 xs:h-8 mr-[5%]"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className={`transition-transform  ${
                    isMenuOpen
                      ? " -rotate-45 translate-y-2 -translate-x-[0.5rem]"
                      : ""
                  }`}
                  d="M4 14L20 14"
                  stroke="#fedd00"
                  strokeWidth="1"
                  strokeLinecap="round"
                />
                <path
                  className={`transition-transform ${
                    isMenuOpen ? "opacity-0 " : ""
                  }`}
                  d="M4 10L20 10"
                  stroke="#fedd00"
                  strokeWidth="1"
                  strokeLinecap="round"
                />
                <path
                  className={`transition-transform ${
                    isMenuOpen
                      ? "rotate-45  translate-x-[0.45rem] -translate-y-[0.18rem]"
                      : ""
                  }`}
                  d="M4 6L20 6"
                  stroke="#fedd00"
                  strokeWidth="1"
                  strokeLinecap="round"
                />
              </svg>
              {/* DESKTOP NAV OPTIONS */}
              <div className=" flex-row space-x-8 text-[#fedd00] font-brandonGrotesque  text-[22px] mr-10 x904:flex xs:hidden">
                <p
                  onClick={() => scrollToSection("about-us")}
                  className=" cursor-pointer"
                >
                  ABOUT US
                </p>
                <p
                  onClick={() => scrollNormal("flavours")}
                  className=" cursor-pointer"
                >
                  FLAVOURS
                </p>
                <p
                  onClick={() => scrollToSection("where-to-buy")}
                  className=" cursor-pointer"
                >
                  WHERE TO BUY
                </p>
                {/* <Link to="/Contact" className="cursor-pointer">
                  {" "}
                  <p className=" cursor-pointer">CONTACT US</p>
                </Link> */}
              </div>

              {/* Overlay Mobile */}
              <div
                className={`fixed top-0 left-0 w-full h-[100vh] bg-[#670001]  z-10 xs:flex justify-center items-center x904:hidden transition-transform duration-[400ms] ease-in  ${
                  isMenuOpen ? "translate-y-0" : "-translate-y-full"
                } `}
              >
                {/* Navigation links */}
                <div className="flex flex-col space-y-4 text-[#fedd00] font-brandonGrotesque  text-2xl">
                  <p
                    onClick={() => scrollToSection("about-us")}
                    className="cursor-pointer"
                  >
                    ABOUT US
                  </p>
                  <p
                    onClick={() => scrollNormal("flavours")}
                    className=" cursor-pointer"
                  >
                    FLAVOURS
                  </p>
                  <p
                    onClick={() => scrollToSection("where-to-buy")}
                    className="cursor-pointer"
                  >
                    WHERE TO BUY
                  </p>
                </div>
              </div>
            </div>

            {/* -----------------------------------CAN IMAGE AND COPY--------------------------------------------------------------- */}

            <div
              id="header"
              className="w-full x904:h-auto xs:h-auto  bg-no-repeat  bg-cover flex justify-center  xs:items-start bg-[#670001] bg-dynamic"
              style={{
                backgroundImage: `url(${backgroundImage})`,
                //backgroundPosition: "bottom center", // Ensures the bottom part is always visible
                backgroundSize: "cover", // Keeps the aspect ratio while covering the div
              }}
            >
              <img
                src={heroImage}
                className=" z-10  desk:mb-[5rem] x904:mb-[6%]  xs:mb-[13%]  desk:mt-[3rem] x904:mt-[3%]  md:mt-[35%] md2:mt-[35%] sms:mt-[35%] sm:mt-[35%]  mob2:mt-[35%] mob3:mt-[35%] mob:mt-[35%] mobMin:mt-[35%] xs:mt-[35%]  xs:max-h-[100%] x904:max-h-[863px] w-auto max-w-[90%] "
                alt="cans & text - THE FAMOUS SPRITZ FROM SPAIN - Crack a La Casera "
              />
            </div>
          </div>
          {/*--------------------------------------------- SECTION END -----------------------------------------------------------------------------
          ---------------------------------------------------------------------------------------------------------------------------------------*/}

          {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////// ABOUT US SECTION //////////////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
          <div className="bg-[#fedd00] w-full flex justify-center">
            <div
              id="about-us"
              className="max-w-[1440px]  w-full flex x904:items-center justify-between x904:flex-row xs:flex-col text-[#c7272f] xs:my-[10%] desk:my-[8rem] mx-12"
            >
              {/* Left Content */}
              <div className="flex-1 font-bold   text-[15rem] leading-[0.8] font-megascopeVariable   xs:text-center p-4">
                <img
                  src={fam}
                  alt="NOW FAMOUS IN THE UK."
                  className="max-w-full h-auto"
                />
              </div>

              {/* Right Content */}
              <div className="flex-1  xl:text-[2.5rem] lg:text-[1.9rem] x904:ml-[40px] x904:text-[1.5rem] md:text-[2.8rem] md2:text-[2.3rem] sms:text-[2.2rem] sm:text-[1.7rem] mob3:text-[1.4rem] mob2:text-[1.2rem] mob:text-[1.1rem] mobMin:text-[1rem] xs:text-[0.9rem] leading-tight font-brandonGrotesqueMd x904:text-left  xs:text-center p-4 xs:mt-[5%] x904:mt-0">
                Savour those casual get-togethers with family and friends in the
                true Spanish way. Made with high-quality Spanish ingredients.
                Simply delicious since 1949. Viva la España!
              </div>
            </div>
          </div>
          {/*--------------------------------------------- SECTION END -----------------------------------------------------------------------------
          ---------------------------------------------------------------------------------------------------------------------------------------*/}
          <div
            className=" w-full bg-no-repeat bg-cover"
            style={{
              backgroundImage: `url(${midImage})`,
              backgroundPosition: "bottom center", // Ensures the bottom part is always visible
              backgroundSize: "cover", // Keeps the aspect ratio while covering the div
            }}
          >
            {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////// FLAVOUR SECTION ///////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
            <div id="flavours" className="  flex justify-center ">
              <div className="max-w-[1440px]  w-full flex x904:items-center justify-between x904:flex-row xs:flex-col text-[#fee42d] my-[5%] mx-12   xl:text-[1.8rem] x1247:text-[1.6rem] lgm:text-[1.41rem] lg:text-[1.3rem] x904:text-[1.15rem] md:text-[2.1rem] md2:text-[1.7rem] sms:text-[1.5rem] sm:text-[1.3rem] mob2:text-[1.2rem] xs:text-[0.9rem] leading-tight  text-center ">
                {/* ---------------------------- Left Content --------------------------------------------------- */}
                <div className="flex-1  xs:text-center p-4 xs:mt-[5%] x904:mt-0">
                  <img
                    src={red}
                    alt="red wine can"
                    className=" desk:max-w-[414px] desk2:max-w-[350px] xl:max-w-[350px] x1247:max-w-[300px] xl1130:max-w-[300px] lgm:max-w-[300px] lg:max-w-[300px] x990:max-w-[300px] x920:max-w-[300px] x904:max-w-[300px] tablet:max-w-[414px] md:max-w-[414px] sms:max-w-[414px] xs:max-w-[100%] h-auto  mx-auto"
                  />
                  <div className=" font-brandonGrotesque mt-[4%] mx-auto x904:w-[90%] sms:w-[90%] sm:w-[94%] xs:w-[100%]">
                    <h2>SODA & LEMON</h2>
                    <br />
                    <p className="font-brandonGrotesqueMd">
                      A lightly sparkling Spanish spritz made with a refreshing
                      blend of tempranillo wine and soda.
                    </p>
                    <br />
                    <p className="font-brandonGrotesqueMd">
                      Per 330ml: 3.4% ABV. 81 kcal.
                    </p>
                  </div>
                </div>
                {/* ---------------------------- Right Content --------------------------------------------------- */}
                <div className="flex-1  xs:text-center p-4 xs:mt-[5%] x904:mt-0">
                  <img
                    src={white}
                    alt="white wine can"
                    className="desk:max-w-[414px] desk2:max-w-[350px] xl:max-w-[350px] x1247:max-w-[300px] xl1130:max-w-[300px] lgm:max-w-[300px] lg:max-w-[300px] x990:max-w-[300px] x920:max-w-[300px] x904:max-w-[300px] tablet:max-w-[414px] md:max-w-[414px] sms:max-w-[414px] xs:max-w-[100%] h-auto  mx-auto"
                  />
                  <div className=" brandonGrotesque mt-[4%] mx-auto x904:w-[90%] sms:w-[90%] sm:w-[94%] xs:w-[100%]">
                    <h2>SODA & LEMON</h2>
                    <br />
                    <p className="font-brandonGrotesqueMd">
                      A lightly sparkling Spanish spritz made with a refreshing
                      blend of verdejo wine and soda.
                    </p>
                    <br />
                    <p className="font-brandonGrotesqueMd">
                      Per 330ml: 2.5% ABV. 72 kcal.
                    </p>
                  </div>
                </div>
                {/* -------------------------------------------------------------------------------------------- */}
              </div>
            </div>
            {/*--------------------------------------------- SECTION END ----------------------------------------------------------------------------
            ---------------------------------------------------------------------------------------------------------------------------------------*/}

            {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////// WHERE TO BUY SECTION //////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}

            <div className=" flex justify-center ">
              <div className="max-w-[1440px]  w-full flex x904:items-center justify-between x904:flex-row xs:flex-col text-[#fee42d] my-[0] mx-12   font-medium xl:text-[1.8rem]  x904:text-[1.8rem] md:text-[2.8rem] md2:text-[2.6rem] sms:text-[2.5rem] sm:text-[2.2rem] mob2:text-[2rem] xs:text-[1.4rem] leading-tight font-brandonGrotesque text-center ">
                <div className="flex-1  xs:text-center  x904:mt-10 xs:mt-[10%]">
                  <div
                    id="where-to-buy"
                    className=" mx-auto x904:w-[90%] sms:w-[90%] sm:w-[94%] xs:w-[100%]"
                  >
                    <h2>WHERE TO FIND US</h2>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            {/* ------------------------------------ WHERE TO BUY BRANDS -------------------------------------------------------- */}
            <div className="  flex justify-center ">
              <div className="xs:w-[55%] x904:w-[100%] gap-x-10 max-w-[1440px]  space w-full flex x904:items-center  justify-center x904:flex-row xs:flex-col text-[#fee42d] x904:my-[2%] mx-12  xs:mt-[2%] xs:mb-[10%]  font-bold xl:text-[1.8rem] x1247:text-[1.6rem] lgm:text-[1.41rem] lg:text-[1.3rem] x904:text-[1.15rem] md:text-[2.1rem] md2:text-[1.7rem] sms:text-[1.5rem] sm:text-[1.3rem] mob2:text-[1.2rem] xs:text-[0.9rem] leading-tight font-brandonGrotesque text-center ">
                <div className="  xs:text-center p-4 xs:mt-[2%] x904:mt-0 ">
                  <a
                    href="https://www.whsmith.co.uk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={whsmith}
                      alt="whsmith logo"
                      className="x904:max-w-[336px] md:max-w-[300px] h-auto mx-auto cursor-pointer"
                    />
                  </a>
                </div>
                <div className="  xs:text-center p-4 xs:mt-[2%] x904:mt-0">
                  <a
                    href="https://www.amazon.co.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={amazon}
                      alt="amazon logo"
                      className="x904:max-w-[336px] md:max-w-[300px] h-auto  mx-auto cursor-pointer"
                    />
                  </a>
                </div>
              </div>
            </div>
            {/*--------------------------------------------- SECTION END ----------------------------------------------------------------------------
            ---------------------------------------------------------------------------------------------------------------------------------------*/}
          </div>
          {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////// FOOTER SECTION ////////////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
          <div
            className=" w-full bg-no-repeat bg-cover"
            style={{
              backgroundImage: `url(${footImage})`,
              backgroundPosition: "top center", // Ensures the bottom part is always visible
              backgroundSize: "cover", // Keeps the aspect ratio while covering the div
            }}
          >
            <div className=" flex justify-center ">
              <div className="max-w-[1440px]  w-full flex x904:items-center justify-between x904:flex-row xs:flex-col text-[#fee42d] my-[0] mx-12   font-medium  leading-tight font-brandonGrotesque text-center ">
                <div className="flex-1  xs:text-center  x904:mt-14 xs:mt-14">
                  <div className=" mx-auto  xs:w-[100%]">
                    <h2 className="x904:text-[1.35rem] md:text-[1.35rem] md2:text-[1.35rem] sms:text-[1.35rem] sm:text-[1.35rem] mob2:text-[1.35rem] xs:text-[1.35rem] mb-4">
                      © 2025 SUNTORY LA CASERA
                    </h2>
                    <p className="x904:text-[0.9rem] md:text-[0.9rem] md2:text-[0.9rem] sms:text-[0.9rem] sm:text-[0.9rem] mob2:text-[0.9rem] xs:text-[0.9rem]  mx-auto x904:max-w-[594px] xs:max-w-[360px] mb-4">
                      Produced in Spain using ingredients of EU and non-EU
                      origin.
                      <br className="x904:block xs:hidden" />
                      &nbsp;Distributed by Lucozade Ribena Suntory Limited under
                      the authority of Schweppes International Limited. La
                      Casera and the La Casera logo are registered trademarks of
                      Schweppes International Limited.
                    </p>
                    <img
                      src={drinkware}
                      alt="drinkware logo"
                      className="max-w-[191px] h-auto  mx-auto"
                    />
                    <br />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="xs:pb-[10%]  x904:py-8  x990:w-[956px] x904:w-[850px] sms:w-[500px] max-w-[1440px] mx-auto grid x904:grid-cols-8 xs:grid-cols-3 gap-2 w-full  place-items-center  x990:text-[0.9rem] mob3:text-[0.9rem] xs:text-[0.6rem] font-bold text-[#fee42d] font-brandonGrotesque">
            
              <div className="  flex justify-center items-center  xs:row-start-1 x904:col-start-4  x904:col-end-6 xs:col-span-full x904:col-span-1  x904:my-0 xs:my-10 ">
                <img
                  onClick={() => scrollNormal("header")}
                  src={crack}
                  alt="Crack a La Cesera "
                  className=" w-[143px] h-auto cursor-pointer"
                />
              </div>

             
              <div className="  text-center x904:col-start-1 ">
                <Link to="/Contact" className="cursor-pointer">
                  CONTACT US
                </Link>
              </div>
              <div className="  text-center x904:col-start-2 cursor-pointer">
                COOKIES
              </div>
              <div className="  text-center x904:col-start-3 cursor-pointer">
                PRIVACY POLICY
              </div>

            
              <div className="  text-center x904:col-start-6 cursor-pointer">
                FACEBOOK
              </div>
              <div className="  text-center x904:col-start-7 cursor-pointer">
                INSTAGRAM
              </div>
              <div className="  text-center x904:col-start-8 cursor-pointer">
                YOUTUBE
              </div>
            </div> */}

            <div className="xs:pb-[10%]  x904:pb-8  x990:w-[476px] x904:w-[476px] sms:w-[500px] max-w-[1440px] mx-auto grid xs:grid-cols-3 gap-2 w-full  place-items-center  x990:text-[0.9rem] mob3:text-[0.8rem] xs:text-[0.7rem] font-bold text-[#fee42d] font-brandonGrotesque">
              {/* Image first on mobile, centered */}
              <div className="  flex justify-center items-center  xs:row-start-1  xs:col-span-full   xs:my-8 ">
                <img
                  onClick={() => scrollNormal("header")}
                  src={crack}
                  alt="Crack a La Cesera "
                  className=" w-[143px] h-auto cursor-pointer"
                />
              </div>

              {/* First 3 text items */}
              <div className="  text-center col-start-2 ">
                <Link to="/Contact" className="cursor-pointer">
                  CONTACT US
                </Link>
              </div>
              {/* <div className="  text-center cursor-pointer">COOKIES</div>
              <div className="  text-center cursor-pointer">PRIVACY POLICY</div> */}
            </div>
          </div>
          {/*--------------------------------------------- SECTION END -----------------------------------------------------------------------------
          ---------------------------------------------------------------------------------------------------------------------------------------*/}
        </div>
      )}
    </div>
  );
};

export default Home;
